import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WindowRef } from '@shared/modules/window-ref/window-ref';
import { IFileMetaData } from '@store/reducers/document-upload/document-upload.reducer';
import { firstValueFrom } from 'rxjs';

export type UploadDocumentsResponse = {
  fileName: string;
};

@Injectable({
  providedIn: 'root',
})
export class DocumentUploadService {
  constructor(
    private http: HttpClient,
    private windowRef: WindowRef,
  ) {}

  async uploadDocuments(
    filesMetaData: IFileMetaData[],
  ): Promise<UploadDocumentsResponse | undefined> {
    const formData = new FormData();

    if (filesMetaData.length > 0) {
      for (const file of filesMetaData) {
        const fetchResponse = await this.windowRef.nativeWindow.fetch(file.objectURL);
        const fetchResponseBlob = await fetchResponse.blob();
        formData.append('files', fetchResponseBlob, file.fileName);
      }

      return firstValueFrom(
        this.http.post<UploadDocumentsResponse>('secure/upload-documents', formData),
      );
    }
  }
}
